<template>
  <div class="header-balance">
    <div style="margin-left:-55px" v-if="balance == null">
      <b-skeleton height="40px" width="100%"></b-skeleton>
    </div>
    <div v-if="balance != null" class="header-balance-container">
      <i :style="{ backgroundColor: iconBg }" :class="icon"></i>
      <div class="header-balance-details">
        <span :style="{ color: tcolor }">{{balance.balance}} FCFA</span>
        <span>{{balance_sub}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["tcolor", "iconBg", "icon","balance","balance_sub"],
  components: {},
  name: "MainBalance",
  data: function () {
    return {
    
    };
  },
  mounted: async function () {
  }
};
</script>
<style scoped lang="css">
</style>
